export const HR_AUTH_SEND_OTP = '/hr/Auth/send-otp'
export const HR_AUTH_VERIFY_OTP = '/hr/Auth/verify-otp'
export const HR_AUTH_REFRESH_TOKEN = '/hr/Auth/refresh-token'
export const HR_AUTH_LOGOUT = '/hr/Auth/logout'
